module.exports = __webpack_public_path__ + "img/big5-4.7f2e71d5.jpg";